import {StyleSheet, PixelRatio} from 'react-native';
import {scale} from "../../../../common/utils";

export default StyleSheet.create({
    filterWrapper:{
        marginTop: 12,
        height: 56,
        flexDirection: 'row',
        position: 'relative',
        alignItems:'center',
        justifyContent: 'center'
    },
    filterScrollWrapper:{
        height: 40,
        overflow:'hidden',
        flex: 1
    },
    scrollHeight:{
        height: 57
    },
    shadowFilter:{
        position: 'absolute',
        left: -14,
        width: 14,
        height: 55,
        marginTop: -5,
    },
    timeFilter:{
        overflow:'hidden',
        paddingLeft: 4,
        flex: 1,
        flexWrap:'nowrap',
        flexDirection:'row'
    },
    timeFilterItem:{
        height: 40,
        alignItems: 'center',
        minWidth: 75,
        paddingHorizontal:12,
        borderRightColor: '#e6e6e6',
        borderRightWidth: 0.5
    },
    timeFilterItemTitleText:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: scale(14),
        color: "#333333",
        height: 20,
    },
    activeTimeFilterItemTitleText:{
        color: "#00CAD8"
    },
    timeFilterSubTitle:{
        marginTop:1,
        paddingHorizontal: 6,
        paddingVertical: 1,
    },
    timeFilterItemSubTitleText:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: scale(10),
        color: "#999999",
    },
    activeTimeFilterSubTitle:{
        backgroundColor: '#00CAD8',
        borderRadius: 8
    },
    activeTimeFilterItemSubTitleText:{
        color: "#FFFFFF"
    },
    placeFilter:{
        width: scale(88),
        height: 40,
        alignItems: 'center'
    },
    placeFilterCity:{
        flexDirection: 'row'
    },
    placeFilterCityText:{
        fontWeight:'bold',
        fontSize: scale(14),
        maxWidth: scale(56),
        color: "#00CAD8",
        height: 20,
    },
    placeFilterDown:{
        alignSelf: 'center',
        marginLeft: 2,
        marginTop: -2
    },
    placeFilterGoTip: {
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: scale(10),
        color: "#999999",
        height: 14,
        marginTop:1
    }
});